import { h } from 'preact';

/**
 * Transform a string into a "handleized" format.
 * @param {string} inputString - The string to handleize.
 * @returns {string} - The handleized string.
 */
function handleize(inputString) {
  return inputString.toLowerCase()
    .trim()
    /* eslint-disable no-useless-escape */
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
  /* eslint-enable no-useless-escape */
}

/**
 * Swatches component that displays product color options.
 * @param {Object} props - Component properties.
 * @param {Object} props.product - The product details.
 * @param {Object} props.currentVariant - The currently selected product variant.
 * @param {Function} props.handleVariantChange - Handler for changing the variant.
 * @returns {JSX.Element|false} The Swatches component or false if color options are not available.
 */
const Swatches = ({ product, 
                    currentVariant, 
                    handleVariantChange, 
                    limit = false }) => {
  const productOptions = product?.optionsWithValues !== undefined ?
        product?.optionsWithValues : 
        product?.variantBySelectedOptions?.selectedOptions;

  const colorOptionIndex = productOptions?.findIndex(o => o.name.toLowerCase().includes('color')) ;
  if (colorOptionIndex < 0) return false;

  const buffer = [];
  const colorVariants = product?.variants.reduce((acc, v) => {
    const option = v.options !== undefined ? v.options : v.selectedOptions;
    if (buffer.includes(option[colorOptionIndex])) return acc;
   
    buffer.push(option[colorOptionIndex]);
    return [...acc, v];
  }, []);

  let limitedColorVariants = colorVariants;
    
  if (limit) limitedColorVariants = colorVariants.slice(0, limit);

  return (
    <div className="flex flex-wrap gap-2 mt-2 items-center">
      {limitedColorVariants.map(variant => {
        const checked = currentVariant.id === variant.id;
        const option = variant.options !== undefined ? 
              variant.options[colorOptionIndex] : 
              variant.selectedOptions[colorOptionIndex].value ;
        const bgColorVar =
          `var(--swatch-${handleize(option)}, #CCC)`;
        return (
          <div key={variant.id}
               className='color-swatch'>
            <input
              checked={checked}
              id={variant.id}
              onChange={() => handleVariantChange(variant.id)}
              type='radio'
              value={variant.id}
              name={`${product.id}-color`}
            />
              <label
                htmlFor={variant.id}
                style={{ backgroundColor: bgColorVar }}
              ></label>
          </div>
        );
      })}
      {colorVariants.length > limitedColorVariants.length && (
        <span className="text-11 text-primary font-medium">+{colorVariants.length - limitedColorVariants.length}</span>
      )}
    </div>
  );
};

export default Swatches;
